<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:'QDSCard'
}
</script>

<style scoped>
.card {
    display: block;
    padding: 20px;
	background-color: white;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
	border-radius: 5px;
	margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue